<template>
  <b-row class="justify-content-center m-0" align-v="center" :style="{ height: '100%' }">
    <div>
      <b-row class="box-content">
        <!-- column left -->
        <b-col class="box-content__left">
          <div v-if="isVerified">
            <ContentVerifiedEmail :email="email" />
          </div>
          <div v-else>
            <div class="mb-u6 text__title">Please verify your email</div>
            <div class="text__description">So we can make sure your account is secure.</div>
            <div class="mb-u6 text_description">
              Click a send button below to send verification email to
              <span class="font-weight-bold">{{ email ? email : 'EMAIL_NOT_DETECT' }}</span>
            </div>
            <div class="d-flex mb-u6">
              <b-button
                variant="primary"
                class="mr-u8"
                style="width: 200px"
                name="send-verify-email-button"
                :disabled="isWaiting || !email || isVerified"
                disable-event-track
                @click="onClickSendVerifyEmail"
              >
                <b-spinner v-if="isLoading" small label="Loading..." class="mb-u1" />

                <span v-else>Send Verification</span>
              </b-button>
              <b-button variant="link" @click="onLogOut()">Logout</b-button>
            </div>
            <div v-if="isWaiting">
              <div class="text__description mb-u6">Email verification has been sent.</div>
              <div class="text__description">
                New email verification can be requested again in
                {{ countDownSecond }} seconds.
              </div>
            </div>
          </div>

          <div v-if="isSendEmailFail || !email" class="text-danger">
            Something went wrong. Please contact admin.
          </div>
        </b-col>
        <!-- column right -->
        <b-col class="box-content__right">
          <div class="d-flex justify-content-center">
            <b-img v-if="isVerified" class="img-right" :src="require(`@/assets/email-2.jpg`)" />
            <b-img v-else class="img-right" :src="require(`@/assets/email-1.jpg`)" />
          </div>
        </b-col>
      </b-row>
    </div>
  </b-row>
</template>

<script>
import { userInfoMixin } from '@/mixins/userInfoMixin';
import User from '@/models/User';
import ContentVerifiedEmail from './components/ContentVerifiedEmail';
import { useAuth } from '../../composables';
import { amplitudeMixin } from '@/mixins/amplitudeMixin';

const { logout } = useAuth();

export default {
  components: {
    ContentVerifiedEmail
  },

  mixins: [amplitudeMixin, userInfoMixin],

  data: () => ({
    email: 'EMAIL NOT FOUND',
    countDownSecond: 0,
    isLoading: false,
    isVerified: false,
    isSendEmailFail: false
  }),

  computed: {
    isWaiting() {
      // wait 60 secs after re send email
      return this.countDownSecond !== 0;
    },

    autoSend() {
      return this.$route.query.autoSend === 'true';
    }
  },

  watch: {
    countDownSecond(value) {
      if (value > 0) {
        setTimeout(() => {
          this.countDownSecond--;
        }, 1000);
      }
    }
  },

  async created() {
    await this.init();
  },

  methods: {
    onClickSendVerifyEmail(event) {
      this.$_amplitudeMixin_onClick(event.currentTarget);

      this.sendVerifyEmail();
    },

    async init() {
      if (!this.user?.email) {
        console.error("can't detect user's email");
        return;
      }

      this.email = this.user.email;

      if (this.user?.confirmed) {
        this.isVerified = true;
      } else {
        const sentVerifyEmailAt = localStorage.getItem('kmutt4life__sent-verify-email-at');

        let shouldSendVerifyEmail = this.autoSend;

        if (sentVerifyEmailAt) {
          const diff = 60 - (Date.now() - sentVerifyEmailAt) / 1000;

          this.countDownSecond = diff > 0 ? Math.floor(diff) : 0;

          // If should auto send, but the time interval is still remains
          // assign auto send to false
          if (shouldSendVerifyEmail && diff > 0) {
            shouldSendVerifyEmail = false;
          }
          // if (diff <= 0) await this.sendVerifyEmail();
        }

        if (shouldSendVerifyEmail) {
          await this.sendVerifyEmail();
        }
        // else {
        //   await this.sendVerifyEmail();
        // }
      }

      this.isLoading = false;
    },

    async sendVerifyEmail() {
      this.clearError();

      if (!this.user?.email) {
        console.log('email not found');

        return;
      }

      this.isLoading = true;

      try {
        await User.api().requestVerifyEmail(this.user.email);
      } catch (error) {
        this.isSendEmailFail = true;
      } finally {
        this.isLoading = false;
      }

      this.countDownSecond = 60;

      localStorage.setItem('kmutt4life__sent-verify-email-at', Date.now());
    },

    async clearError() {
      this.isSendEmailFail = false;
    },

    onLogOut() {
      logout();
    }
  }
};
</script>

<style scoped>
.text__title {
  font-weight: 700;
  font-size: 26.6px;
  line-height: 32px;
  color: #3b3e66;
}

.text__description {
  font-weight: 400;
  font-size: 15.2px;
  line-height: 22px;
  color: #3b3e66;
}

.image__background {
  height: 352px;
  background: #f1f1fd;
  border-radius: 10.4px;
}

.box-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 50px 10px;
  padding: 5%;
}
.box-content__right .img-right {
  max-width: 400px;
}

@media only screen and (max-width: 767px) {
  .box-content {
    flex-direction: column-reverse;
    gap: 20px 25px;
  }
  .box-content__right .img-right {
    min-width: 250px;
    width: 80%;
  }
}

@media only screen and (min-width: 768px) and (max-width: 991.98px) {
  .box-content {
    gap: 50px 0;
  }
  .box-content__right .img-right {
    min-width: 250px;
    width: 100%;
  }
}
</style>
